<template>
  <div>
    <LeftBoxHistoryList />
  </div>
</template>

<script>
import LeftBoxHistoryList from "./LeftBoxHistoryList"
export default {
  components: { LeftBoxHistoryList },
  props: {},
  emits: [],
  data() {
    return {}
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
